/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/
export class OrderStatusListForm {
  public limit: number;
  public offset: number;
  public keyword: string;
  public count: boolean;
  public status: number;

  constructor(orderstatuslistForm: any) {
    this.limit = orderstatuslistForm.limit || 0;
    this.offset = orderstatuslistForm.offset || 0;
    if (orderstatuslistForm.keyword) {
      this.keyword = orderstatuslistForm.keyword;
    }
    this.count = false;
    if (orderstatuslistForm.status) {
      this.status = orderstatuslistForm.status;
    }
  }
}
